import { render } from "./BookingToday.vue?vue&type=template&id=694b90a4&scoped=true"
import script from "./BookingToday.vue?vue&type=script&lang=js"
export * from "./BookingToday.vue?vue&type=script&lang=js"

import "./BookingToday.vue?vue&type=style&index=0&id=694b90a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-694b90a4"]])

export default __exports__